<template>
  <div :key="'webboard-thread-list'">
    <div v-if="loading">Loading</div>

    <!-- Debug -->
    <!-- <div v-if="debug">
      {{ topic }}
    </div> -->

    <li v-else-if="topics.length > 0" class="cursor-pointer email__mail-item"   
      v-for="(topic, index) in topics"
      :key="String(topic.id)" :style="{transitionDelay: (index * 0.1) + 's'}">
     
      <CommonTopicListItem :index="index" :data="dataAdapter(topic)" :isSelected="false">
        <TopicHeader :data="dataAdapter(topic)" />
      </CommonTopicListItem>
    </li>
    <div v-else>
      {{ $t("no-webboard") }}
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { state } from "../../data";
import CommonTopicListItem from "../CommonTopicListItem.vue";
import { constructTopicsFromList } from "../../data";

export default {
  components: {
    CommonTopicListItem,
    TopicHeader: () => import("./TopicHeader.vue")
  },
  data() {
    return {
      localData: state.local,
      topics: [],
      loading: true,
      debug: false
    }
  },
  watch: {
    async 'localData.activeListType'(type) {
      await this.refreshTopicList(type);
      this.loading = false;
    },
    topics(topicList) {                         
      if (Array.isArray(topicList)) {           
        if (topicList.length > 0) {             
          this.$forceUpdate();                  
        }                                       
      }                                         
    }                                           
  },                                            
  // computed: {                                
  //   messages() {                             
  //     return this.localData.messagePool["pm"]
  //   }                                        
  // },                                         
  methods: {                                    
    dataAdapter(_topic) {                            
      if (!_topic) { return null }              
                                                
      if (_topic.data) {                        
        const { id, topic, sendDate, readDate, fromUser, fromUserCode, message, courseOutlineRegistration } = _topic.data;
                                                
        const { subject, subjectCode, subjectName } = courseOutlineRegistration;
                                                
        const sender_name =                     
          `${fromUser ? fromUser.nameLocal : "" }
            ${fromUser ? fromUser.surnameLocal : "" }`;
        const sender_code =                     
          `${fromUserCode ? fromUserCode : ""}` 
                                                
        return {                                
          ..._topic.data,                       
          id,                                   
          type: "pm",                           
          topic,                                
          subject,                              
          subjectName,                          
          subjectCode,                          
          senderUUID: fromUser ? fromUser.photo : null,
          sender_name,                          
          sender_code,                          
          unread: readDate ? false : true,      
          time: sendDate,                       
          isStarred: true,                      
          content: message                      
        }                                       
      }                                         
      return null                               
    },                                          
    messageAdapter(message) {                   
      const { id, topic, sendDate, readDate, fromUser, fromUserCode, courseOutlineRegistration } = message;
      const { subject, subjectCode, subjectName } = courseOutlineRegistration;
      const sender_name =                       
        `${fromUser ? fromUser.nameLocal : "" } 
          ${fromUser ? fromUser.surnameLocal : "" }`;
      const sender_code =                       
        `${fromUserCode ? fromUserCode : ""}`   
      return {                                  
        ...message,                             
        id,                                     
        type: "pm",                             
        topic,                                  
        subject,                                
        subjectName,                            
        subjectCode,                            
        senderUUID: fromUser ? fromUser.photo : null,
        sender_name,                                        
        sender_code,                                        
        unread: readDate ? false : true,                    
        time: sendDate,                                     
        isStarred: true,                                    
        content: message.message                            
      }                                                     
    },                                                      
    async refreshTopicList() {                              
      this.topics = await constructTopicsFromList("webboard", "all");
      const topics = await constructTopicsFromList("webboard", this.localData.activeListType);
                                                            
      if (topics) {                                         
        this.topics = topics                                
      } else {                                              
        this.localData.activeListType = "all"               
      }                                                     
      this.loading = false;                                 
    }                                                       
  },                                                        
  async mounted() {                                         
    await this.refreshTopicList();                          
  },                                                        
  async beforeUpdated() {                                   
    await this.refreshTopicList();                          
  }                                                         
}                                                           
</script>                                                   
                                                            